// @core/api/endpoints/secret/rewrap.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EncryptResponse,
  RewrapRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Rewrap ciphertext
 * Re-encrypts existing ciphertext with the latest key version without exposing plaintext. Use after key rotation to update stored ciphertexts.
 */
export async function Rewrap(
  engine_id: string,
  key_name: string,
  data: RewrapRequest,
  options?: RequestOptions
): Promise<EncryptResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/rewrap/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<EncryptResponse>(requestPath, data, requestOptions);
}
